import { useCallback } from 'preact/hooks';

export default function useBotRequest({ twitchUsername, twitchAccessToken }) {
  return useCallback(
    (url) => {
      const body = JSON.stringify({
        twitchUsername,
      });

      const headers = new Headers();
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', twitchAccessToken);

      let success = false;
      return fetch(url, {
        method: 'POST',
        body,
        headers,
      })
        .then((response) => {
          success = response.ok;
          return response.json();
        })
        .catch(() => null)
        .then((result) => {
          return { data: result, success };
        });
    },
    [twitchUsername, twitchAccessToken]
  );
}